import axios from 'axios';

/** Matches API 403 body when quiz is career-locked (`QuizLockedException`). */
export const QUIZ_LOCKED_ERROR_CODE = 'QUIZ_LOCKED';

export const PLAY_DIFFICULTY_LOCKED_ERROR_CODE = 'PLAY_DIFFICULTY_LOCKED';

export function isQuizLockedApiError(err: unknown): boolean {
  if (!axios.isAxiosError(err) || err.response?.status !== 403) return false;
  const data = err.response.data as { code?: string } | undefined;
  return data?.code === QUIZ_LOCKED_ERROR_CODE;
}

export function isPlayDifficultyLockedApiError(err: unknown): boolean {
  if (!axios.isAxiosError(err) || err.response?.status !== 403) return false;
  const data = err.response.data as { code?: string } | undefined;
  return data?.code === PLAY_DIFFICULTY_LOCKED_ERROR_CODE;
}
